export default theme => ({
  container: {
    padding: 5,
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
  }
});
